import { IReport, IReportValue } from './IReport';
import { IReportTemplate } from '@shared/interfaces';

export interface IUpdateReportMeta {
    id?: string;
    template?: IReportTemplate;
    reportStartDate?: Date;
    reportEndDate?: Date;
    dueDate?: string;
}

export interface IAcceptGuidanceValue {
    id?: string;
    guidanceValues?: { [key: string]: boolean };
    reportValues?: { [key: string]: IReportValue };
}

export interface ISelectLanguageForReport {
    id?: string;
    selectedLanguage?: string;
}

export interface IUpdateReport extends IReport {
    updateType?: UpdateReportType;
    document?: { name: string; body: string | ArrayBuffer }[];
    deleteDocuments?: string[];
    signDocument?: (string | ArrayBuffer)[];
}

export enum UpdateReportType {
    admin,
    signResponsible,
    sigSpecialist,
    fillOut,
    acceptedGuidance,
    selectLanguage
}
